<app-cyclops-nav></app-cyclops-nav>

<!-- Solutions Page Header with Background Video -->
<section class="cyclops header" id="home">
  <div class="header5-content">
    <div class="cyclops-header bg video-header">
      <!-- 🎥 Background Video -->
      <video autoplay muted loop playsinline class="video-bg">
        <source src="assets/images/headervideo.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div class="video-dark-overlay"></div>

      <!-- Overlay Content -->
      <div class="video-overlay">
        <div class="container">
          <div class="row">
            <div class="col-md-10 offset-md-1">
              <div class="center-text text-center" style="justify-content: center;">
                <div>
                  <h1>
                    <span class="bold-text">Let's Contact</span>
                  </h1>
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<Div>
<div class="contact-container" >
  <h2>Contact Us</h2>
  <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="name">Name</label>
      <input formControlName="name" type="text" id="name" required />
    </div>

    <div class="form-group">
      <label for="email">Email</label>
      <input formControlName="email" type="email" id="email" required />
    </div>

    <div class="form-group">
      <label for="subject">Subject (optional)</label>
      <input formControlName="subject" type="text" id="subject" />
    </div>

    <div class="form-group">
      <label for="message">Message</label>
      <textarea formControlName="message" id="message" rows="5" required></textarea>
    </div>

    <button type="submit" [disabled]="contactForm.invalid">Send</button>
  </form>

  <div *ngIf="successMessage" class="success-message">
    {{ successMessage }}
  </div>
</div>

</Div>

<div class="follow-cyclops text-center">
  <p class="follow-title">
    Follow Cyclops Defense for updates and announcements:
  </p>

  <div class="follow-icons">
    <a href="https://www.linkedin.com" target="_blank" aria-label="LinkedIn">
      <i class="fa-brands fa-linkedin-in"></i>
    </a>

    <a href="https://x.com" target="_blank" aria-label="X">
      <i class="fa-brands fa-x-twitter"></i>
    </a>
  </div>
</div>

<app-cyclops-footer></app-cyclops-footer>

